import { ArcStack } from "@src/core/ui";
import React from "react";
import { ZoneItem } from '@src/features/zones/pages/zones-page/components/ZoneItem';
import { ZoneListProps } from '@src/features/zones/pages/zones-page/types';
import { useSelector } from "react-redux";
import { selectSelectedZone } from "@src/features/zones/redux";

export const ZoneList: React.FC<ZoneListProps> = (props ) => {
  const { zones } = props;
  const selectedZone = useSelector(selectSelectedZone);
    
  return (
    <ArcStack spacing={1} marginTop={2} marginBottom={1.2}>
      {zones.map((zone) => {
        const isSelected = selectedZone?.id === zone.id;
        return (
          <ZoneItem 
            key={zone.id} 
            zone={zone} 
            isSelected={isSelected}
          />
        );
      })}
    </ArcStack>
  );
};